import { useEffect, useState } from 'react';
const useIsScrollable = (ref) => {
    const [isScrollable, setIsScrollable] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const element = ref.current;
    useEffect(() => {
        if (element === null) {
            return () => { };
        }
        const handleScroll = () => {
            if (element.scrollTop || element.scrollTop === 0) {
                setIsScrolled(element.scrollTop > 0);
            }
        };
        const observer = new ResizeObserver(() => {
            setIsScrollable(element.scrollHeight > element.clientHeight);
        });
        observer.observe(element);
        element.addEventListener('scroll', handleScroll);
        return () => {
            observer.disconnect();
            element.removeEventListener('scroll', handleScroll);
        };
    }, [element]);
    return { isScrollable, isScrolled };
};
export default useIsScrollable;
